<template>
  <el-card>
    <!-- 查询表单 -->
    <el-form :inline="true" :model="searchFactor" class="search-form">
      <el-form-item label="主题:" >
        <el-input v-model="searchFactor.theme"></el-input>
      </el-form-item>
      <el-form-item label="实验室准入教程:" >
        <el-select v-model="searchFactor.basicState" placeholder="请选择" style="width:200px">
          <el-option  label= "全部" value="" ></el-option>
          <el-option  label= "是" value="1" ></el-option>
          <el-option  label= "否" value="0" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleCreateSafeBook">创建</el-button>
      </el-form-item>
    </el-form>
    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      :stripe ="true"
      :border = "true"
      height="calc(100vh - 200px)"
      max-height="calc(100vh - 200px)"
      :highlight-current-row ="true"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 100%">
      <el-table-column
        type="index"
        label="序号"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="theme"
        label="主题"
        width="300" >
      </el-table-column>
      <el-table-column
        prop="basicState"
        label="实验室准入教程"
        min-width="70">
        <template slot-scope="scope">
          <span v-if = "scope.row.basicState == 1" style="color: greenyellow"> 是</span>
          <span v-else style="color: red" > 否</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="content"
        label="内容"
        min-width="400"
         :formatter="formatContent">
      </el-table-column>
      <el-table-column
        prop="initFolderName"
        label="资源文件夹"
        width="200">
      </el-table-column>
      <el-table-column
        prop="active"
        width="70"
        label="状态" >
      <template slot-scope="scope">
        <span v-if = "scope.row.active == 0" style="color: red"> 未发布</span>
        <span v-else style="color: greenyellow" > 已发布</span>
      </template>
      </el-table-column>
      <el-table-column
        prop="createUser"
        label="创建者"
        width="120">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="100">
      </el-table-column>
      <el-table-column label="操作" min-width="120px">
        <template slot-scope="scope" >
          <el-dropdown split-button type="primary" @command="handleCommand">
            管理
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided :command = '{event:"doActiveSafeBook",index:scope.$index, data:scope.row}'>
                <i :class="scope.row.active == 0 ? 'el-icon-star-on':'el-icon-star-off' "  :style="scope.row.active == 0 ?'color:rgb(40, 238, 10)' :'color:rgb(246, 102, 18)'" ></i> 
                <span>{{scope.row.active == 0?'发布':'撤销'}}</span>
              </el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleViewSafeBook",index:scope.$index, data:scope.row}'> <i class="el-icon-search" style="color:rgb(39, 193, 231)" ></i> <span>预览</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleEditSafeBook",index:scope.$index, data:scope.row}'><i class="el-icon-edit" style="color:rgb(41, 10, 239)" ></i> <span>编辑</span></el-dropdown-item>
              <el-dropdown-item  divided :command = '{event:"sendSafeBook",index:scope.$index, data:scope.row}'><i class="el-icon-share" style="color:rgb(12, 139, 16)"></i> <span>发布给用户</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleDelete", index:scope.$index,data:scope.row}'><i class="el-icon-delete-solid" style="color:rgb(246, 102, 18)" ></i> <span>删除</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页插件 -->
    <el-pagination style="margin:10px"
      background

      layout="total,prev, pager, next"
      @current-change="handleCurrentChange"
      :page-size="pager.pageSize"
      :total="pager.totalCount">
    </el-pagination>
    <!-- 创建通知公告主题弹框 -->
    <el-dialog :close-on-click-modal="false" width="50%" :visible.sync="dialogVisual.initNoticeThemeVisual" v-on:close ="clearInitNoticeForm" >
      <div slot="title" class="dialog-footer">
        <span> 创建安全责任书主题 </span>
      </div>
      <el-form :model="initSafeBookForm"  label-width="20%">
        <el-form-item  label="主题:" style="width:90%">
          <el-input v-model="initSafeBookForm.theme"  autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="实验室准入教程:" style="width: 90%">
          <el-checkbox v-model="initSafeBookForm.basicState"></el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureCreate">创建</el-button>
      </div>
    </el-dialog>

  <!--  -->
  <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisual.configUserVisual" fullscreen v-on:close ="clearUserPaperForm" >
    <div slot="title" style="text-align: left">
          <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
          <span style="font-size:18px;  font-weight:700">分发安全责任书</span>
      </div> 
    <el-form :inline="true" :model="searchUserFactor" class="demo-form-inline">
        <el-form-item label="用户名:" >
          <el-input v-model="searchUserFactor.userName"></el-input>
        </el-form-item>
        <el-form-item label="姓名:" >
          <el-input v-model="searchUserFactor.fullName"></el-input>
        </el-form-item>
        <el-form-item label="部门:" >
          <el-select v-model="searchUserFactor.deptId" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in searchUserFactor.deptOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选中:" >
          <el-select style="width:100%"  v-model="searchUserFactor.selected" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="已经分发" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onUserSearch">查询</el-button>
         <el-button type="primary" @click="sendAllPeople">全部分发</el-button> 
        </el-form-item>
      </el-form>
    <el-table
      :data="tableUserData"
      :stripe ="true"
      :border = "true"
      :highlight-current-row ="false"
      height="calc(100vh - 250px)"
      max-height="calc(100vh - 250px)"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 100%">
    <el-table-column
      type="index"
      label="序号"
      :index="indexMethod">
    </el-table-column>
    <el-table-column
      prop="fullName"
      label="姓名"
     min-width="150px">
    </el-table-column>
    <el-table-column
      prop="usrName"
      label="用户名"
      min-width="150px"
      width="120">
    </el-table-column>
    <el-table-column
      prop="mobilePhone"
      label="手机"
      min-width="150px">
    </el-table-column>
    <el-table-column
      prop="email"
      min-width="150px"
      label="邮件">
    </el-table-column>
    <el-table-column
      prop="deptName"
      min-width="180px"
      label="团队">
    </el-table-column>
    <el-table-column
      prop="gentle"
      min-width="50px"
      label="性别" :formatter="formatGentle">
    </el-table-column>
    <el-table-column min-width="200px" prop="picture" label="签名">
        <template slot-scope="scope">
          <img v-if = "scope.row.signImage != null && scope.row.signImage!=''" :src="scope.row.signImage" fit="fill"  height="70"/>
        </template>
      </el-table-column>
    <el-table-column
      prop="active"
      min-width="70px"
      label="状态" >
      <template slot-scope="scope">
          <span v-if = "scope.row.active == 1" style="color: greenyellow">  激活</span>
          <span v-else  style="color: red" > 禁用</span>
      </template>
    </el-table-column>
    <el-table-column label="操作" min-width="120px">
      <template slot-scope="scope">
        <el-button
        size="mini" 
        :type="scope.row.selected == 0 ? 'warning' :'success'"
        @click="handleSendPaper(scope.$index, scope.row)">{{scope.row.selected == 0?'选中':'移除'}}</el-button>
      </template>
    </el-table-column>
    </el-table>
    <el-pagination style="margin: 10px;"
      background
      layout="total,prev, pager, next"
      @current-change="handleUserCurrentChange"
      :page-size="userPager.pageSize"
      :current-page.sync="userPager.curPage"
      :total="userPager.totalCount">
    </el-pagination>
      <div slot="footer" class="dialog-footer">
      </div>
    </el-dialog>
  </el-card>
</template>                     
<script>
  // 引入组件
import axios from  '@/api/axiosConfig'
import SERVICE_URL  from  '@/api/url'
import {stringIsNullOrEmpty} from  '@/api/utils'
import {PAGE_SIZE,MESSAGE_DURATION,fileType} from  '@/api/constant'
export default {
  name : 'pc_ctr_safe_book_list',
  data() {
    return {
      searchFactor: {
        theme: '',
        id :'',
        basicState : ''
      },
      dialogVisual:{
        initNoticeThemeVisual: false,
        configUserVisual : false
      },
      initSafeBookForm:{
        theme:'',basicState:false
      },
      searchUserFactor: {
        selected : '',
        fullName: '',
        userName: '',
        deptId :'',
        safeBookId:'',
        deptOptions : []
      },
      tableData: [],
      tableUserData:[],
      pager:{
        currentPage:0,
        totalCount:0,
        pageSize : PAGE_SIZE
      },
      userPager:{
        totalCount:0,
        curPage : 0,
        pageSize : PAGE_SIZE
      },
    }
  },
  methods : {
    handleCommand(command){
      let index  = command.index
      let row = command.data
      let event = command.event
      switch(event){
        case 'handleDelete' :
            this.handleDelete(index,row)
            break
        case 'handleEditSafeBook' :
            // this.handleEditSafeBook(index,row)
            let left =  (window.screen.availWidth-10-1000)/2
            let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
            width=1000,height=1000,left=${left},top=100`;
            window.open(SERVICE_URL+"/#/pc_ctr_safe_book_edit/" +row.id,"test",params);
            break
        case 'handleViewSafeBook':
            //this.handleViewSafeBook(index,row)
            // this.handleEditSafeBook(index,row)
            let left0 =  (window.screen.availWidth-10-1000)/2
            let params0 = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
            width=1000,height=1000,left=${left0},top=100`;
            window.open(SERVICE_URL + "/#/pc_ctr_editor_view/" +row.id +"?fileType=" + fileType.SAFE_BOOK,"安全责任书预览",params0);
            break
        case 'doActiveSafeBook':
            this.doActiveSafeBook(index,row)
            break

        case 'sendSafeBook':
            this.doSendSafeBook(index,row)
            break
      }
    },

    indexMethod(index){
      return  index + 1
    },

    doSendSafeBook(index, row ){
      this.searchUserFactor.safeBookId = row.id
      if(this.searchUserFactor.deptOptions.length == 0 ){
        this.deptListLoad();
      }
      this.userListLoad(1)
      this.dialogVisual.configUserVisual = true
    },
    sendAllPeople(){
      let url = "/bc/exa/safeBook/bindAllActiveUser" 
      let dat0 = {
        id: this.searchUserFactor.safeBookId
      }
      let s = JSON.stringify(dat0)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            showClose: true,
            message: '操作成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          setTimeout(()=>{ this.userListLoad(1)},200)
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
      });
    },
    handleSendPaper(index,row){
      let url = "/bc/exa/safeBook/bind" 
      let selected = row.selected === 0 ? 1 : 0
      let dat0 = {
        safeBookId: this.searchUserFactor.safeBookId,
        userId : row.id,
        selected
      }
      let s = JSON.stringify(dat0)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            showClose: true,
            message: '操作成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          row.selected = selected
          this.$set(this.tableUserData, index, row);
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      });
    },
    deptListLoad(){
      let url = "/bc/exa/dept/getDeptTree"
      let dat = {}
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          if( response.data.data.length !== 0){
            response.data.data.forEach(t=>{
              if(t.level == 1){
                this.searchUserFactor.deptOptions.push({value: t.id,label: t.deptName })
              }
            })
          }else{
              this.$message({
                showClose: true,
                message: '团队列表未查询到数据！',
                type: 'warning',
                duration: MESSAGE_DURATION
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        }) 
      })
    },
    onUserSearch(){
      this.userListLoad(1)
    },
    userListLoad(pageNo){
      let url = "/bc/exa/usr/userSafeBookPage"
      let { 
        selected,
        userName,
        fullName,
        safeBookId,
        deptId
      } =  this.searchUserFactor 
      let dat = {
        pageSize: PAGE_SIZE,
        selected,
        fullName,
        userName,
        safeBookId,
        deptId,
        pageNo
      }
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
          if (response.data.code === 0) {
              let dat = response.data.data;
            if(dat.data.length !== 0){
              this.tableUserData = [];
              dat.data.forEach(t=>this.tableUserData.push(t))
              this.userPager.totalCount = dat.totalDataCount;
              this.userPager.curPage = pageNo ;
            } else {
              this.$message({
                showClose: true,
                message: '未查询到用户信息！',
                type: 'info',
                duration: MESSAGE_DURATION
              })
            }
          }else{
            this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error',
                duration: MESSAGE_DURATION
            })
          }
        }).catch( (err) => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
          })
      });
    },

    formatGentle(row, index){
      if(row.gentle == 1){
          return '男';
      }else{
          return '女';
      }
    },
    handleUserCurrentChange(val){
      this.userListLoad(val)
    },
    formatContent(row , index){
      if(row.content == null || row.content == ''){
        return ''
      }
      if(row.content.length > 400 ){
        return row.content.substring(0,400)
      }
      return row.content
    },
    handleCurrentChange(val){
      this.safeBookListLoad(val);
    },
    safeBookListLoad(pageNo){
      let url = "/bc/exa/safeBook/page"
      let { 
          theme,basicState
      } = this.searchFactor 
      let dat0 = {
          pageSize: PAGE_SIZE,
          theme,
          pageNo,basicState
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.data.length !== 0){
              this.tableData = [];
              dat.data.forEach(t=>this.tableData.push(t))
              this.pager.totalCount = dat.totalDataCount
              this.pager.currentPage = pageNo           
          } else {
            this.$message({
              showClose: true,
              message: '未查询到通知信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        });
    },
    onSearch(){
      this.safeBookListLoad(1)
    },
    clearUserPaperForm(){
      this.dialogVisual.configUserVisual = false
      this.searchUserFactor.safeBookId = ''
      this.searchUserFactor.selected =''
      this.searchUserFactor.fullName =''
      this.searchUserFactor.userName =''
      this.searchUserFactor.deptId =''
    },

    handleCreateSafeBook(){
      this.dialogVisual.initNoticeThemeVisual = true
    },
    handleDelete(index, row){
      this.$confirm('即将删除主题['+row.theme+']的安全责任书!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doDeleteSafeBook(row)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除！'
        });
      })
    },
    doDeleteSafeBook(row){
      let datBat = {id: row.id}
      let url = "/bc/exa/safeBook/safeBookDelete"
      let s = JSON.stringify(datBat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '删除成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.safeBookListLoad(1);
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
   

    doActiveSafeBook(index,row){
      let actState = row.active === 0 ? 1 : 0
      let dat = {
        id: row.id,
        active: actState
      }
      let url = "/bc/exa/safeBook/safeBookActive"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '操作成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.safeBookListLoad(1);
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    ensureCreate(){
      let theme = this.initSafeBookForm.theme.trim();
      let basicState = this.initSafeBookForm.basicState ? 1 : 0
      try{ 
        stringIsNullOrEmpty(theme,'请输入主题!');
      }catch (e){
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return
      }
      let dat = {
        theme : theme,
        basicState:basicState
      }
      let url = "/bc/exa/safeBook/create"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.dialogVisual.initNoticeThemeVisual = false;
          this.$message({
            showClose: true,
            message: '创建安全责任书主题成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.clearInitNoticeForm();
          this.safeBookListLoad(1);
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err)=> {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    clearInitNoticeForm(){
      this.initSafeBookForm.theme = ''
      this.initSafeBookForm.basicState = false
    },
    clearUplaodAttachForm(){
      this.noticeAttach.id = ''
      this.noticeAttach.url= ""
    }
  },
  created () {
   
    this.safeBookListLoad(1);
  }
}
</script>

<style lang="less" scoped>
.el-card {
  height: 99%
}

.search-form{
  margin-top: 10px;
  text-align:left 
}
</style>



// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_safe_book_list.vue